import { render } from "./EditLabelInput.vue?vue&type=template&id=55d4d788"
import script from "./EditLabelInput.vue?vue&type=script&lang=js"
export * from "./EditLabelInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__